import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { singletonHook } from 'react-singleton-hook';

import { ISupplementResponseStatus } from '@interfaces/lookups';
import { userDataSelector } from '@store/features/auth/user/selectors';
import { handleGetSupplementResponseStatuses } from '@store/features/supplementResponseStatuses/actions';
import {
  supplementResponseStatusesErrorSelector,
  supplementResponseStatusesIsLoadingSelector,
  supplementResponseStatusesIsReadySelector,
  supplementResponseStatusesSelector,
} from '@store/features/supplementResponseStatuses/selectors';
import useDispatch from '@store/hooks/useDispatch';

import useFetchLookupData from './useFetchLookupData';

const useSupplementResponseStatuses = (): ISupplementResponseStatus[] => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const data = useSelector(supplementResponseStatusesSelector);
  const isLoading = useSelector(supplementResponseStatusesIsLoadingSelector);
  const isReady = useSelector(supplementResponseStatusesIsReadySelector);
  const error = useSelector(supplementResponseStatusesErrorSelector);
  const user = useSelector(userDataSelector);

  const handleFetch = useCallback(() => {
    !user?.isAdmin && user?.organizationId && dispatch(handleGetSupplementResponseStatuses());
  }, [dispatch, user]);

  useFetchLookupData({
    isReady,
    isLoading,
    error: error && t('errors.supplementResponseStatusesError'),
    handleFetch,
  });

  return data;
};

export default singletonHook([], useSupplementResponseStatuses);
